import { BaseEntity } from '../services/api/universal.service';

export enum DocumentRecipientType {
    RH = 'RH',
    SUPERVISOR = 'SUPERVISOR',
    ADMIN = 'ADMIN',
    POST_SUPERVISOR = 'POST_SUPERVISOR',
    USER = 'USER',
}

export enum DocumentStatus {
    PENDING = 'PENDING',
    VIEWED = 'VIEWED',
    DOWNLOADED = 'DOWNLOADED',
}

export interface IFileResponse {
    id: string;
    originalName: string;
    fileName: string;
    size: number;
    mimeType: string;
    url: string;
}

export interface ISenderResponse {
    id: string;
    name: string;
    email: string;
    role?: string;
}

export interface IRecipientResponse {
    id: string;
    name: string;
    email: string;
    role: string;
    postName?: string; // Nome do posto para síndicos
}

export interface IDocumentResponse extends BaseEntity {
    recipientType: DocumentRecipientType;
    recipientId?: string;
    description?: string;
    status: DocumentStatus;
    fileId: string;
    file: IFileResponse;
    senderId: string;
    sender: ISenderResponse;
    recipient?: IRecipientResponse;
    companyId?: string;
    /** Auditoria — data da primeira visualização (UI). Detalhes técnicos só no backend. */
    viewedAt?: string | Date | null;
    /** Auditoria — data do primeiro download (UI). Detalhes técnicos só no backend. */
    downloadedAt?: string | Date | null;
}

/** Metadados do dispositivo enviados na atualização de status (prova jurídica). */
export interface IDocumentClientEvidence {
    userAgent?: string;
    platform?: string;
    isNative?: boolean;
    deviceModel?: string;
    manufacturer?: string;
    os?: string;
    osVersion?: string;
    browser?: string;
    screen?: string;
    language?: string;
    timezone?: string;
    appVersion?: string;
}


export interface ICreateDocumentDto {
    recipientType: DocumentRecipientType;
    recipientId?: string;
    description?: string;
    fileId: string;
}

export interface IUpdateDocumentDto {
    recipientType?: DocumentRecipientType;
    recipientId?: string;
    description?: string;
    status?: DocumentStatus;
}

export interface IDocumentFilters {
    recipientType?: DocumentRecipientType;
    status?: DocumentStatus;
    page?: number;
    limit?: number;
}

export interface IDocumentPaginationResponse {
    data: IDocumentResponse[];
    total: number;
    page: number;
    limit: number;
    totalPages: number;
}

export interface IAvailableUser {
    id: string;
    name: string;
    email: string;
    login: string;
    role: string;
    roleLabel: string;
    postName?: string; // Nome do posto para síndicos
}
